module.exports = __webpack_public_path__ + "static/media/skill2.414942b2.gif";